import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, NgZone, OnDestroy, OnInit, } from '@angular/core';
import { NgControl, } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { TranslateService } from '@ngx-translate/core';
import { FileDownloadService, FileUploadService, ModalService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { identifier } from '@uipath/angular/utilities';
import { readFileContent } from '@utils/file.utils';
import { UI_QUEUE_SCHEMA_MAX_FILE_SIZE } from '@validators';
import { BehaviorSubject, Subject, } from 'rxjs';
var UiQueueSchemaComponent = /** @class */ (function () {
    function UiQueueSchemaComponent(ngControl, _cd, _upload, _snack, _translate, _downloadService, _modal, _zone) {
        var _this = this;
        this.ngControl = ngControl;
        this._cd = _cd;
        this._upload = _upload;
        this._snack = _snack;
        this._translate = _translate;
        this._downloadService = _downloadService;
        this._modal = _modal;
        this._zone = _zone;
        this.labelText = 'Value';
        this.schemaName = 'schemaName';
        this.disabled = false;
        this.confirmUpload = false;
        this.shouldLabelFloat = false;
        this.stateChanges = new Subject();
        this.focused = false;
        this.errorState = false;
        this.valueChange = new EventEmitter();
        this.describedBy = '';
        this.reading$ = new BehaviorSubject(false);
        this.reading = new EventEmitter(false);
        this.fileName = '';
        this._required = false;
        this._initialExisted = false;
        this.registerChange = function (_) { };
        this.registerTouch = function (_) { };
        this._onOkay = function (target) {
            _this.confirmUpload = false;
            _this._zone.runOutsideAngular(function (_) { return target.click(); });
        };
        this.ngControl.valueAccessor = this;
        this._randomName = identifier();
        this.id = 'ui-queue-schema-' + this._randomName;
    }
    Object.defineProperty(UiQueueSchemaComponent.prototype, "value", {
        get: function () {
            return this.currentValue;
        },
        set: function (state) {
            this.currentValue = state;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiQueueSchemaComponent.prototype, "placeholder", {
        get: function () {
            return this.labelText;
        },
        set: function (plh) {
            this.labelText = plh;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiQueueSchemaComponent.prototype, "empty", {
        get: function () {
            return this.currentValue == null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiQueueSchemaComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = req;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    UiQueueSchemaComponent._isValidJson = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    UiQueueSchemaComponent.prototype.ngOnInit = function () {
        this._initialExisted = !!this.currentValue;
        if (this._initialExisted) {
            this.fileName = this.initialFileName;
        }
    };
    UiQueueSchemaComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
    };
    UiQueueSchemaComponent.prototype.writeValue = function (value) {
        this.currentValue = value;
        this._cd.markForCheck();
        this.stateChanges.next();
    };
    UiQueueSchemaComponent.prototype.registerOnChange = function (fn) {
        this.registerChange = fn;
    };
    UiQueueSchemaComponent.prototype.registerOnTouched = function (fn) {
        this.registerTouch = fn;
    };
    UiQueueSchemaComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this._cd.detectChanges();
    };
    UiQueueSchemaComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    UiQueueSchemaComponent.prototype.onContainerClick = function (_event) { };
    UiQueueSchemaComponent.prototype.onClear = function () {
        this.fileName = '';
        this.writeValue(null);
        this.registerChange(null);
        if (!this._initialExisted) {
            this.ngControl.control.markAsPristine();
        }
    };
    UiQueueSchemaComponent.prototype.onFileChange = function (files) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resultAsString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reading$.next(true);
                        this.reading.emit(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        if (!this._upload.isFileItemValid(files[0], null, UI_QUEUE_SCHEMA_MAX_FILE_SIZE)) {
                            this._snack.error(this._translate.instant("queue_upsert_form_invalid_schema_file", {
                                maxSize: '256KB',
                            }));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, readFileContent(files[0])];
                    case 2:
                        resultAsString = _a.sent();
                        if (!UiQueueSchemaComponent._isValidJson(resultAsString)) {
                            this._snack.error(this._translate.instant("queue_json_schema_not_valid"));
                            return [2 /*return*/];
                        }
                        this.writeValue(resultAsString);
                        this.registerChange(resultAsString);
                        this.fileName = files[0].name;
                        return [3 /*break*/, 4];
                    case 3:
                        this.reading$.next(false);
                        this.reading.emit(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UiQueueSchemaComponent.prototype.onDownload = function () {
        this._downloadService.downloadStringAsFile(this.schemaName + "DataJsonFile.json", 'application/json', this.currentValue);
    };
    UiQueueSchemaComponent.prototype.confirmUploadDialog = function (event) {
        var _this = this;
        if (this.confirmUpload) {
            var target_1 = event.target;
            event.stopPropagation();
            this._modal.onConfirm(null, function () { return _this._onOkay(target_1); }, function () { }, this._translate.instant('queue_json_schema_confirm_upload'));
        }
    };
    return UiQueueSchemaComponent;
}());
export { UiQueueSchemaComponent };
